import BaseModel from './BaseModel';
import Stock from './Stock';
import DataManager from '../DataManager';

function parseNumericField(value) {
  if (value == null || value === '') {
    return NaN;
  }
  return parseFloat(String(value).replace(/,/g, ''));
}

class Transaction extends BaseModel {
  date;

  get stockTicker() {
    return this._stockTicker;
  }
  set stockTicker(ticker) {
    this._stockTicker = ticker != null ? String(ticker).toUpperCase() : ticker;
  }

  get purchasePrice() {
    return parseNumericField(this._purchasePrice);
  }
  set purchasePrice(price) {
    this._purchasePrice = price.toString();
  }

  get numberOfShares() {
    return parseNumericField(this._numberOfShares);
  }
  set numberOfShares(numberOfShares) {
    this._numberOfShares = numberOfShares.toString();
  }

  getStock() {
    return Stock.find(this.stockTicker);
  }

  getIdAsDatabaseCommand() {
    return {
      user_sub: { S: DataManager.getInstance().congitoUserIdentityId },
      id: { S: this.id }
    };
  }

  getAsDatabaseCommand() {
    return {
      id: { S: this.id },
      user_sub: { S: DataManager.getInstance().congitoUserIdentityId },
      date: { S: new Date(this.date).toISOString() },
      stockTicker: { S: this.stockTicker },
      purchasePrice: { N: this.purchasePrice.toString() },
      numberOfShares: { N: this.numberOfShares.toString() }
    };
  }
}

export default Transaction;
